import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

interface ProjectFormProps {
  projectDescription: string;
  setProjectDescription: (value: string) => void;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  loading: boolean;
}

export const ProjectForm: React.FC<ProjectFormProps> = ({
  projectDescription,
  setProjectDescription,
  onSubmit,
  loading
}) => {
  return (
    <form onSubmit={onSubmit} className="bg-white rounded-xl shadow-lg p-6 mb-8">
      <div className="mb-6">
        <label className="block text-gray-700 text-lg font-bold mb-3">
          وصف المشروع
        </label>
        <textarea
          value={projectDescription}
          onChange={(e) => setProjectDescription(e.target.value)}
          className="w-full p-4 border-2 border-indigo-100 rounded-lg h-40 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all"
          required
          placeholder="اكتب وصفاً تفصيلياً لمشروعك هنا..."
          dir="rtl"
          disabled={loading}
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className={`
          w-full py-3 px-6 rounded-lg text-lg font-semibold
          transition-all duration-200 flex items-center justify-center
          ${loading 
            ? 'bg-indigo-300 cursor-not-allowed' 
            : 'bg-indigo-600 hover:bg-indigo-700 active:transform active:scale-95'
          }
          text-white shadow-md hover:shadow-lg
        `}
      >
        {loading ? (
          <>
            <LoadingSpinner />
            <span className="mr-3">جاري التحليل...</span>
          </>
        ) : (
          'تحليل المشروع'
        )}
      </button>
    </form>
  );
};